
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import Loader from 'components/Loader'
import Integration from 'components/Integration'
import {fetchIntegrations} from 'redux/modules/integrations/actions'
import {getAllConnectedIntegrations} from 'redux/modules/integrations/selectors'
import {getCurrentMerchant} from 'redux/modules/currentUser/selectors'
import {connect} from 'react-redux'

export class IntegrationsView extends React.Component {
  static propTypes = {
    isFetching: PropTypes.bool,
    fetchIntegrations: PropTypes.func,
    integrations: PropTypes.array
  }

  componentDidMount() {
    const {fetchIntegrations} = this.props
    fetchIntegrations()
  }

  render() {
    const {isFetching} = this.props

    if (isFetching) {
      return <div className='integrations-view'><Loader /></div>
    }

    return (
      <div className='integrations-view container'>
        {this.renderIntroText()}
        {this.renderIntegrations()}
      </div>
    )
  }

  renderIntroText() {
    const {integrations} = this.props

    if (!integrations || !integrations.length) {
      return (
        <div className='integrations-view_intro'>
          You don{`'`}t have any active integrations.
        </div>
      )
    } else {
      return (
        <div className='integrations-view_intro'>
          Your active integrations:
        </div>
      )
    }
  }

  renderIntegrations() {
    const {integrations} = this.props

    if (!integrations) return null

    return (
      <div className='integrations-view_items'>
        {integrations ? integrations.map((integration, index) => {
          const {id, connected, serviceId, icon, costConfig, title} = integration

          return (
            <Integration
              key={index}
              integrationId={id}
              connected={connected}
              serviceId={serviceId}
              icon={icon}
              costConfig={costConfig}
              title={title}
              link
            />
          )
        }) : null}
      </div>
    )
  }
}

const mapStateToProps = (state, props) => {
  return {
    merchantId: getCurrentMerchant(state).id,
    integrations: getAllConnectedIntegrations(state),
    isFetching: state.integrations.isIntegrationsFetching
  }
}

const mapDispatchToProps = {
  fetchIntegrations
}

export default connect(mapStateToProps, mapDispatchToProps)(IntegrationsView)



// WEBPACK FOOTER //
// ./client/views/IntegrationsView/index.js